// Misc
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

// Atoms
import Container from 'atoms/Container';
import Typography from 'material-ui/Typography';
import ButtonBase from 'material-ui/ButtonBase';
// import Parallax from 'atoms/Parallax';

// Components
import Helmet from 'components/Helmet';
import Header from 'components/Header';
import FooterMenu from 'components/Footer/Menu';

// Video
import iphoneWebmVideo from 'assets/video/landing.webm';
import iphoneMp4Video from 'assets/video/landing.mp4';

// Styles
import styles from './styles';

@withStyles(styles)
export default class FeaturesPage extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Helmet />
        <Header activeMenuLink="/features" />

        <div className={classes.mainSection}>
          <div className={classes.mainSectionText}>
            <Container className={classes.mainSectionContainer}>
              <Typography className={classes.mainSectionTextTitle}>
                A mobile app{'\r\n'}for your students
              </Typography>
              <Typography className={classes.mainSectionTextDescription}>
                Empower new and existing students to easily search for a tutor,
                {'\r\n'}see when they’re available, and book a session from anywhere,
                {'\r\n'}in seconds. Our mobile app allows you to stay top of mind 24/7.
              </Typography>
            </Container>
          </div>
          <div className={classes.mainSectionIphone}>
            <Container className={classes.mainSectionContainer}>
              <div className={classes.mainSectionIphoneInner}>
                <video autoPlay loop muted playsInline>
                  <source type="video/webm" src={iphoneWebmVideo} />
                  <source type="video/mp4" src={iphoneMp4Video} />
                </video>
              </div>
            </Container>
          </div>
        </div>

        <div className={classes.purpleStripe}>
          <div className={classes.purpleStripeText}>
            <Container className={classes.purpleStripeContainer}>
              <Typography className={classes.purpleStripeTextTitle}>
                Accepting payments has never been easier
              </Typography>
              <Typography className={classes.purpleStripeTextDescription}>
                Instantly start accepting Apple Pay, Alipay, WeChat Pay,
                and any major credit card through your website and mobile app.
              </Typography>
              <ButtonBase
                className={classes.purpleStripeTextButton}
                component="a"
                href="mailto:hello@tewtor.com"
              >
                Request a demo
              </ButtonBase>
            </Container>
          </div>
        </div>

        <div className={classes.dashboard}>
          <div className={classes.dashboardText}>
            <Container className={classes.dashboardContainer}>
              <Typography className={classes.dashboardTextTitle}>
                Super admin
              </Typography>
              <Typography className={classes.dashboardTextDescription}>
                An admin hub like no other. Maximize efficiency and supercharge
                profitability - manage tutors&apos; availability and schedules with ease,
                instantly confirm or create bookings,
                track earnings, and much, much more.
                <br /><br />
                We built a calendar system from the ground up which
                takes care of the gritty stuff like timezones and
                double bookings. All you have to do is set your tutor’s
                availability and watch the bookings come in. No more
                planners, spreadsheets or endless scheduling phone
                calls, everything is clear and organized in one place.
              </Typography>
            </Container>
          </div>
          <div className={classes.dashboardImage}>
            <Container className={classes.dashboardContainer}>
              <div className={classes.dashboardImageInner} />
            </Container>
          </div>
        </div>

        <div className={classes.blueStripe}>
          <div className={classes.blueStripeInner}>
            <div className={classes.blueStripeText}>
              <Container className={classes.blueStripeContainer}>
                <Typography className={classes.blueStripeTextTitle}>
                  Live collaboration
                </Typography>
                <Typography className={classes.blueStripeTextDescription}>
                  Our best-in-class, simple and secure online collaboration
                  platform allows tutors and students to
                  connect seamlessly via web or mobile. Live HD
                  video and audio, instant messaging, a powerful
                  whiteboard with a host of tools, and ultra-fast file
                  sharing. This is virtual learning at a whole new
                  level.
                </Typography>
              </Container>
            </div>
            <div className={classes.blueStripeImage}>
              <Container className={classes.blueStripeContainer}>
                <div className={classes.blueStripeImageInner} />
              </Container>
            </div>
          </div>
        </div>

        <div className={classes.onlineNow}>
          <div className={classes.onlineNowText}>
            <Container className={classes.onlineNowContainer}>
              <Typography className={classes.onlineNowTextTitle}>
                Online Now Mode
              </Typography>
              <Typography className={classes.onlineNowTextDescription}>
                No more wasted tutor time between sessions or off-peak hours.
                Whenever a tutor is free, simply switch on Online Now mode
                to make them immediately available. Students get last-minute
                or urgent homework help and tutors maximize efficiency.
                {'\r\n'}Win-win.
              </Typography>
            </Container>
          </div>
          <div className={classes.onlineNowImage}>
            <Container className={classes.onlineNowContainer}>
              <div className={classes.onlineNowImageInner} />
            </Container>
          </div>
        </div>

        <div className={classes.greenStripe}>
          <div className={classes.greenStripeInner}>
            <div className={classes.greenStripeText}>
              <Container className={classes.greenStripeContainer}>
                <Typography className={classes.greenStripeTextTitle}>
                  Analytics
                </Typography>
                <Typography className={classes.greenStripeTextDescription}>
                  Track everything that is important to you. A suite
                  of powerful analytics tools to give you actionable
                  insights in real-time. Instantly see when and what
                  your students want to learn. Track how your
                  tutors are performing. Monitor your revenue as
                  you grow your tutoring business.
                </Typography>
              </Container>
            </div>
            <div className={classes.greenStripeImage}>
              <Container className={classes.greenStripeContainer}>
                <div className={classes.greenStripeImageInner} />
              </Container>
            </div>
          </div>
        </div>

        <div className={classes.customApp}>
          <div className={classes.customAppText}>
            <Container className={classes.customAppContainer}>
              <Typography className={classes.customAppTextTitle}>
                Custom branded app
              </Typography>
              <Typography className={classes.customAppTextDescription}>
                Everything is better when you can call it yours.
                Increase brand awareness and student engagement.
                Give us your logo and we’ll do the rest.
              </Typography>
            </Container>
          </div>
          <div className={classes.customAppImage}>
            <Container className={classes.customAppContainer}>
              <div className={classes.customAppImageInner} />
            </Container>
          </div>
        </div>

        <div className={classes.footer}>
          <Container>
            <FooterMenu />
          </Container>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Features/index.js